import React, { useEffect, useRef, useState } from "react";
import pdf from "./respublica-luty.pdf"

const PageGazetaFebuary = () => {
  useEffect(() => {
    window.location.href = pdf
  })
};

export default PageGazetaFebuary
